export default import.meta.ROLLDOWN_FILE_URL_HV6b6z81kKhR47in7kWQhA